var map = {
	"./cn/ios.png": "a36D",
	"./en/ios.png": "L7Oa",
	"./th/ios.png": "N3Fp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KNkc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1 ^\.\/.*\/ios\.png$
// module id = KNkc
// module chunks = 1